// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file app_event/instanceEvent/instanceevent.proto (package instanceEvent, syntax proto3)
/* eslint-disable */

import { RPC } from "../../runtime";

/**
 * @generated from message instanceEvent.InstanceEventsRequest
 */
export type InstanceEventsRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * @generated from field: instanceEvent.UserContext user_context = 3;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message instanceEvent.InstanceEventsResponse
 */
export type InstanceEventsResponse = {
/**
 * @generated from field: repeated instanceEvent.InstanceEvent events = 1;
 */
events?: InstanceEvent[];
}
;
/**
 * @generated from message instanceEvent.InstanceEvent
 */
export type InstanceEvent = {
/**
 * Timestamp
 *
 * @generated from field: string ts = 1;
 */
ts?: string;
/**
 * Stream
 *
 * @generated from field: string stream = 2;
 */
stream?: string;
/**
 * User name
 *
 * @generated from field: string user_name = 3;
 */
userName?: string;
/**
 * Label
 *
 * @generated from field: string label = 4;
 */
label?: string;
}
;
/**
 * @generated from message instanceEvent.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc instanceEvent.InstanceEventService.GetInstanceEvents
 */
export const InstanceEventService_GetInstanceEvents = new RPC<InstanceEventsRequest,InstanceEventsResponse>("POST", "/getInstanceEvents");
